/* Staff records with licence expiry (docs/plans/phase2-staff-records.md §6). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.prose {
  max-width: 75ch;
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-2) var(--space-4);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--rule);
}

.item:last-child {
  border-bottom: 0;
}

.itemMain {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.viewer {
  width: 100%;
  height: 70vh;
  border: 1px solid var(--border);
}

.viewerImage {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
}
